import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { APP_PATHS, PAGE_PATHS } from '../../../../../types';
import { policyComplianceDefaultFilter } from '../../../../../views/Policies/PolicyComplianceDashboard/utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/policy-compliance/')({
  validateSearch: zodValidator(withDefaults(schema.POLICY_COMPLIANCE, defaultFilter, policyComplianceDefaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      app: APP_PATHS.ASSETS,
      path: PAGE_PATHS.POLICY_COMPLIANCE,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
